const defaultCountryAliases = ['US', 'USA', 'U.S.', 'U.S.A.', 'United States', 'United States of America'];

const isUnitedStatesCountry = country => defaultCountryAliases.indexOf(country) !== -1 || !country;

const getValueFromPath = (object, path) => path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : ''), object);

const isValidZipCodeValue = value => Boolean(value && /^\d{5}(-\d{4})?$/.test(value));

const isWholeBuildingValue = value => value?.toString().toLowerCase() === 'true';

const isValidSquareFootageValue = value => /^\d{1,12}(\.0+)?$/.test(value);

const isValidParcelSizeValue = (value) => {
  const normalizedValue = String(value).replace(/,/g, '');
  if (!/^\d+(\.\d{1,2}0*)?$/.test(normalizedValue)) return false;
  const numericValue = Number(normalizedValue);
  return numericValue >= 0 && numericValue <= 50000000;
};

const isEmptyField = (path, RefName) => ({
  path,
  RefName,
  pattern: /\S+/,
  message: 'This is a required field',
  emptyCheck: true,
});

const isEmailField = (path, RefName) => ({
  path,
  RefName,
  // eslint-disable-next-line no-useless-escape
  pattern: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  message: 'Invalid email',
});

// const isDateField = (path, RefName) => ({
//   path,
//   RefName,
//   // eslint-disable-next-line no-useless-escape
//   pattern: /^(19|20)\d{2}\-(0?[1-9]|1[0-2])\-(0?[1-9]|[12][0-9]|3[01])$/,
//   message: 'Invalid Date',
// });

const isDecimalField = (path, RefName) => ({
  path,
  RefName,
  // eslint-disable-next-line no-useless-escape
  pattern: /^\d+(\.\d{1,2})?$/,
  message: 'Must be a numeric value up to 2 decimal places',
});

const isWholeBuildingSquareFootageField = (path, RefName, wholeBuildingPath = 'isWholeBuilding.value') => ({
  path,
  RefName,
  validate: (fieldValue, payload) => {
    if (!isWholeBuildingValue(getValueFromPath(payload, wholeBuildingPath)) || !fieldValue) return true;
    return isValidSquareFootageValue(fieldValue);
  },
  message: 'Must be a whole number up to 12 digits',
});

const isSuiteSquareFeetField = (path, RefName, wholeBuildingPath = 'isWholeBuilding.value') => ({
  path,
  RefName,
  validate: (fieldValue, payload) => {
    if (isWholeBuildingValue(getValueFromPath(payload, wholeBuildingPath)) || !fieldValue) return true;
    return /^\d+(\.\d{1,2})?$/.test(fieldValue);
  },
  message: 'Must be a numeric value up to 2 decimal places',
});

const isParcelSizeField = (path, RefName) => ({
  path,
  RefName,
  validate: fieldValue => !fieldValue || isValidParcelSizeValue(fieldValue),
  message: 'Must be a number between 0 and 50,000,000 with up to 2 decimal places',
});

const isZipCodeField = (path, RefName, countryPath = 'country.value') => ({
  path,
  RefName,
  validate: (fieldValue, payload) => {
    if (!isUnitedStatesCountry(getValueFromPath(payload, countryPath))) return true;
    return isValidZipCodeValue(fieldValue);
  },
  message: 'Zip must be 5 digits or ZIP+4',
});

export {
  isEmptyField,
  isEmailField,
  isDecimalField,
  isWholeBuildingSquareFootageField,
  isSuiteSquareFeetField,
  isParcelSizeField,
  isZipCodeField,
  isUnitedStatesCountry,
  isValidZipCodeValue,
};
